import {Component} from "preact";
import styles from "./styles.scss";
import ConfigService from "../../../../../../services/ConfigService";
import {isIE} from "../../../../../../utilities/detectIE";
import {newDate} from "../../../../../../utilities/date";
import SimpleDate from "../../../../../common/date/simple-date";
import LetterIcon from "../../../../../common/letter-icon";
import CustomDate from "../../../../../common/date/custom-date";

export default class MessageListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: ConfigService.userProfile().reference
        };
    }

    static defaultProps = {
        message: {},
        showUser: false,
        sender: {}
    };

    render(props, state, context) {
        const isFromOther = this.state.user !== this.props.message.createdBy;
        const classes = [
            styles.message,
            (isFromOther ? styles.other : styles.self),
            (isIE() ? styles.ie : null)
        ].filter(i => i).join(' ');
        const date = <CustomDate date={this.props.message.createdAt} format={'HH:mm'}/>;

        const user = () => !(props.showUser && isFromOther) ? null : (
            <div className={styles.userText}>
                <span>{props.sender.name}</span>
            </div>
        );

        return (
            <div class={classes}>
                {user()}
                <div className={styles.contentRow}>
                    <div className={styles.textBox}>
                        {props.message.content}
                    </div>
                    <div className={styles.dateText}>{date}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/message-list-item/index.js